export default __webpack_public_path__ + "static/media/kahsh-foundation-bg.517a42f1.png";